export default "__VITE_ASSET__B_7ioPzH__"